// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sKRB","colBig":"styles_colBig__3Mebg","colSmall":"styles_colSmall__EUMcv","shopifyNameWrapper":"styles_shopifyNameWrapper__KEdx2"};